import { useMediaQuery, useTheme } from "@mui/material";

const useResponsive = () => {
    const theme = useTheme();

    // Verifica se a largura é menor ou igual a 600px
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

    return isMobile;
};

export default useResponsive;
